import React, { useState } from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "UserPool";

const Singup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    
    const onSubmit = (event) => {
        event.preventDefault();
        UserPool.signUp(email, password, [], null, (err, data) => {
            if (err) {
                console.error('error msg', err)
            }
            console.log('signup successfully', data)
        })

        // UserPool.signUp({
        //     username: this.state.username,
        //     password:this.state.password,
        //     attributes: {
        //         email: this.state.email
        //     }
        // })

    }

    // const resetPassword = () => {
    //     const user = new CognitoUser({
    //         Username: userId,
    //         Pool: UserPool,
    //       });
    
    //       const authDetails = new AuthenticationDetails({
    //         Username: userId,
    //         Password: pass
    //       });
    // }

    return (
        <div>
            <form onSubmit={onSubmit}>
                <label>email</label>
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                <label>Password</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <button type="submit">Signup</button>
            </form>
        </div>
    )
}

export default Singup;